const {isArray} = Array;
const {indexOf, slice} = [];

export {isArray, indexOf, slice};
